import { FormButtonRow } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { HolterConfigureData } from '@common/validation/customControls/cardiology/holter/holterConfigureSchemas';
import { CustomControlCode } from '@common/enums';
import { ProcessContext } from '@frontend/components/pages/episodeCategory/carePath/process/processContext';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { HolterConfigureButton } from '../customComponents/HolterConfigureButton';
import { HolterConfigureInfoAlert } from '../customComponents/HolterConfigureInfoAlert';
import { HolterConfigureWarnings } from '../customComponents/HolterConfigureWarnings';

export function HolterConfigureEdit(): JSX.Element {
    const { processActivityId, onChange } = useProcessActivityEditContext<HolterConfigureData>();
    const { expandProcessActivity } = useDefinedContext(ProcessContext);
    const { process } = useDefinedContext(ProcessContext);
    const isExternalExamination = process.activities.some(
        (activity) => activity.serviceActivity.customControlCode === CustomControlCode.HolterExternalExaminationRequest
    );

    useEffect(() => {
        if (processActivityId) {
            expandProcessActivity(processActivityId);
        }
    }, [processActivityId, expandProcessActivity]);

    return (
        <>
            <HolterConfigureInfoAlert />
            <HolterConfigureWarnings />
            <FormButtonRow>
                <HolterConfigureButton
                    name="Stel holter in"
                    onChange={onChange}
                    processActivityId={processActivityId}
                    showHolterInstructionModal={isExternalExamination}
                />
            </FormButtonRow>
        </>
    );
}
